import { Component, Injector, Input, OnDestroy, OnInit } from '@angular/core';
import { NavigationStart, Router, RouterOutlet } from '@angular/router';
import { AuthService } from './services/auth.service';
import { CommonModule } from '@angular/common';
import { CookieService } from 'ngx-cookie-service';
import { interval, Subscription } from 'rxjs';
import {ApiService} from "./services/api.service";

@Component({
  selector: 'app-root',
  standalone: true,
  imports:[RouterOutlet, CommonModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit, OnDestroy {
  private cookieService: CookieService;
  private sessionCheckSubscription?: Subscription;
  public isLogged: boolean = false;
  public username = '';
  public role = '';

  constructor(
    private authService: AuthService,
    private injector: Injector,
    private router: Router,
  ) {
    this.cookieService = this.injector.get(CookieService);
  }

  ngOnInit(): void {
    // Set up periodic session validation check (every 5 minutes)
    this.sessionCheckSubscription = interval(5 * 60 * 1000).subscribe(() => {
      if (this.authService.checkAuthorization()) {
        // Check session validity based on cookie expiration instead of API call
        if (!this.authService.isSessionValid()) {
          this.logout();
        }
      }
    });

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        // Check if user is authorized on each navigation
        this.isLogged = this.authService.checkAuthorization();

        if (this.isLogged) {
          try {
            const loginInfo = JSON.parse(this.cookieService.get('oadr_login'));
            this.username = loginInfo.username;
            this.role = loginInfo.role;
          } catch (e) {
            // If cookie parsing fails, log the user out
            this.logout();
          }
        } else {
          // If not on login page and not logged in, redirect to login
          if (!event.url.includes('/login')) {
            this.router.navigate(['/login']);
          }
        }
      }
    });
  }

  ngOnDestroy(): void {
    // Clean up subscription to prevent memory leaks
    if (this.sessionCheckSubscription) {
      this.sessionCheckSubscription.unsubscribe();
    }
  }

  logout() {
    this.cookieService.delete('oadr_login');
    this.cookieService.delete('enoc_session');
    this.isLogged = false;
    this.username = '';
    this.role = '';
    this.router.navigate(['/login']);
  }

  /**
   * Check if current user is admin
   * @returns Boolean indicating if user is admin
   */
  isAdmin(): boolean {
    return this.authService.isAdmin();
  }
}
